import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { map, switchMap, tap } from 'rxjs/operators';
import { LiveClassService } from '../../home/live-class.service';
import { ProfileServiceConfigurationService } from '../../shared/profile-service-configuration.service';
import { ClassType } from '../../shared/types/class-types.enum';
import { LiveClassScheduleDto } from '../../shared/types/live-class-schedule-dto';

@Component({
  selector: 'lp2-live-class-week-schedule',
  templateUrl: './live-class-week-schedule.component.html',
  styleUrls: ['./live-class-week-schedule.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LiveClassWeekScheduleComponent implements OnChanges {
  public weekLiveClassSchedules: Array<LiveClassScheduleDto> = [];
  @Input() public showSchedule = false;
  public dayNumberArray = [];
  public isLoading = false;
  public carouselSettings = {
    margin: 25,
    nav: true,
    stagePadding: 45,
    responsive: {
      0: {
        items: 1,
        slideBy: 1,
      },
      525: {
        items: 3,
        slideBy: 3,
      },
      992: {
        items: 4,
        slideBy: 4,
      },
    },
  };

  constructor(
    private liveClassService: LiveClassService,
    private profileServiceConfigurationService: ProfileServiceConfigurationService,
    public cdRef: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('showSchedule' in changes) {
      this.showSchedule ? this.openWeekSchedule() : this.closeWeekSchedule();
    }
  }

  public toggleWeekSchedule() {
    if (this.showSchedule) {
      this.closeWeekSchedule();
      return;
    }
    this.openWeekSchedule();
  }

  private fetchWeekSchedule$() {
    this.isLoading = true;
    return this.profileServiceConfigurationService.hybridClassTypeDesktopUIEnabled$().pipe(
      switchMap((hybridClassTypeDesktopUIEnabled) => {
        return this.liveClassService.getWeekLiveClassSchedules().pipe(
          map((schedules) => {
           const filteredSchedules = hybridClassTypeDesktopUIEnabled ? schedules : removeHybridClasses(schedules);
           filteredSchedules.forEach((schedule) => {
            this.dayNumberArray.push(new Date(schedule.date).getDay());
           });
           return filteredSchedules;
          }),
          tap(() => this.isLoading = false)
        )
      })
    )
  }

  private openWeekSchedule() {
    if (this.weekLiveClassSchedules.length === 0) {
      this.fetchWeekSchedule$().subscribe((liveClassSchedules) => {
        this.weekLiveClassSchedules = liveClassSchedules;
        this.showSchedule = true;
        this.cdRef.detectChanges();
      });
    } else {
      this.showSchedule = true;
      this.cdRef.detectChanges();
    }
  }

  private closeWeekSchedule() {
    this.showSchedule = false;
    this.cdRef.detectChanges();
  }

}

const removeHybridClasses = (schedules: Array<LiveClassScheduleDto>): Array<LiveClassScheduleDto> =>
  schedules.map((schedule) => ({
    ...schedule,
    liveClasses: schedule.liveClasses.filter((lc) => lc.classType !== ClassType.HYBRID),
  }));



// WEBPACK FOOTER //
// ./ts/app/home/live-class-week-schedule/live-class-week-schedule.component.ts